function splitText(
  originalText: string,
  maxCharacters: number,
  withDots = true,
) {
  const transformed = {
    truncated: '',
    more: '',
  }

  if (!originalText) {
    return transformed
  }

  // Strip HTML first
  originalText = originalText.replace(/(<([^>]+)>)/gi, '')

  if (originalText.length <= maxCharacters) {
    transformed.truncated = originalText
    return transformed
  }

  transformed.truncated =
    originalText.substr(0, maxCharacters) + (withDots ? '...' : '')
  transformed.more = originalText.substr(maxCharacters, originalText.length)

  return transformed
}

export default splitText
